import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Toolbar, AppBar, Badge } from '@mui/material';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import FmdBadIcon from '@mui/icons-material/FmdBad';
import { useSetAtom } from 'jotai';
import {
  // notificationDrawerOpenAtom,
  selectedCustomerIdAtom,
  selectedLeadIdAtom,
} from '../../Atoms';
import AccountMenu from './AccountMenu';
import {
  isNotificationDenied,
  isNotificationSupported,
} from '../../Helpers/notifications';
import Fab from './Fab';
import ThemeFab from '../Button/ThemeFab';
import { FullSizeCenteredFlexBox } from '../FlexBox';
import TargetProgressPaper from './TargetProgressPaper';
import CreditsPaper from './CreditsPaper';
import PrioritiesAlert from './PrioritiesAlert';
import RedemptionPaper from './RedemptionPaper';
import { APP_ROUTES, FULLPAGE_ROUTES } from '../../Router/routes';

const classes = {
  toolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  fab: {
    backgroundColor: (theme) => theme.palette.background.paper,
  },
};

const Navbar = function Navbar({
  onLogout,
  unreadMessagesCounter = 0,
  remainingSMS = null,
  userRoles,
  callTargets,
  priorities = [],
  userRedemptionData,
}) {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation().pathname;

  const setSelectedLeadId = useSetAtom(selectedLeadIdAtom);
  const setSelectedCustomerId = useSetAtom(selectedCustomerIdAtom);
  // const setNotificationDrawerOpen = useSetAtom(notificationDrawerOpenAtom);
  const [notificationCounter, setNotificationCounter] = useState(
    unreadMessagesCounter
  );
  const handlePurchaseHistoryPage = () => {
    setSelectedCustomerId('');
    setSelectedLeadId('');
    navigate(APP_ROUTES.PURCHASEHISTORY);
  };
  useEffect(() => {
    setNotificationCounter(unreadMessagesCounter);
  }, [unreadMessagesCounter]);

  const redemptionAverage =
    userRedemptionData?.totalPractices && userRedemptionData?.totalAnsweredNum
      ? (userRedemptionData?.totalPractices /
          userRedemptionData?.totalAnsweredNum) *
        100
      : 0;
  const userRedemption =
    userRedemptionData?.practices && userRedemptionData?.answeredNum
      ? (userRedemptionData?.practices / userRedemptionData?.answeredNum) * 100
      : 0;

  const isNotLimitedOperator = Boolean(
    userRoles?.find(({ roleId }) => roleId !== 'LIMITEDOPERATOR')
  );

  return (
    <AppBar
      sx={{
        display:
          (Object.keys(APP_ROUTES).find(
            (key) =>
              APP_ROUTES[key] === location && FULLPAGE_ROUTES.includes(key)
          ) ||
            location === '/401') &&
          'none',
      }}
      position="relative"
      color="transparent"
      align="right"
      elevation={0}
    >
      <Toolbar sx={classes.toolbar}>
        <FullSizeCenteredFlexBox
          justifyContent="flex-end"
          gap="12px"
          paddingTop="16px"
        >
          {isNotLimitedOperator && <PrioritiesAlert priorities={priorities} />}
          {userRedemptionData?.totalPractices > 0 && (
            <RedemptionPaper
              disabled={!userRedemptionData}
              redemptionReached={userRedemption >= redemptionAverage}
            />
          )}
          <TargetProgressPaper callTargets={callTargets} />
          <CreditsPaper
            userRoles={userRoles}
            remainingSMS={remainingSMS}
            handlePurchaseHistoryPage={handlePurchaseHistoryPage}
          />
          {isNotificationSupported() && isNotificationDenied() && (
            <Fab
              title={intl.messages.SYSTEM_NOTIFICATIONS_DISABLED}
              href="chrome://settings/content/notifications"
              size="large"
            >
              <FmdBadIcon />
            </Fab>
          )}

          <Fab title="HELP" href="https://docs.databeasy.it/" size="large">
            <HelpOutlineRoundedIcon />
          </Fab>

          {/*           <Fab
            title={intl.messages.NOTIFICATIONS}
            onClick={() => setNotificationDrawerOpen(true)}
            size="large"
          >
            <Badge
              color="error"
              badgeContent={notificationCounter}
              invisible={!notificationCounter}
            >
              <NotificationsNoneOutlinedIcon id="notificationShower" />
            </Badge>
          </Fab> */}
          {userRoles?.find(({ roleId }) => roleId === 'SUPERADMIN') && (
            <Fab
              size="large"
              title={intl.messages.SETTINGS}
              onClick={() => {
                navigate(APP_ROUTES.SETTINGS);
              }}
            >
              <TuneRoundedIcon />
            </Fab>
          )}

          <ThemeFab size="large" />

          <AccountMenu onLogout={onLogout} userRoles={userRoles} />
        </FullSizeCenteredFlexBox>
      </Toolbar>
    </AppBar>
  );
};

Navbar.propTypes = {
  onLogout: PropTypes.func.isRequired,
  unreadMessagesCounter: PropTypes.number,
  openSidebar: PropTypes.func.isRequired,
  desktop: PropTypes.bool,
  remainingSMS: PropTypes.number,
  sidebarOpen: PropTypes.bool,
  userRoles: PropTypes.array,
};

export default Navbar;
